import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/Users/kei/repos/opera-lang/src/components/Layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const Part = makeShortcode("Part");
const Ex = makeShortcode("Ex");
const Tr = makeShortcode("Tr");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`花の歌`}</h1>
    <div style={{
      padding: 16,
      margin: 8,
      border: '1px solid orange'
    }}>
  こちらのコンテンツは新しいサイトに移行しています。以下のリンクから新サイトをご覧ください。
  <div style={{
        margin: 16,
        textAlign: "center",
        overflowWrap: "break-word"
      }}>
    <a href="https://capriccioso.info/opera/carmen/la-fleur">https://capriccioso.info/opera/carmen/la-fleur</a>
  </div>
    </div>
    <h4>{`La fleur tu m'avais jetée`}</h4>
    <p>{`ホセがカルメンに愛を語る独唱。`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#youtube"
        }}>{`Youtube の動画`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#translation"
        }}>{`対訳と語義解説`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#sheet"
        }}>{`楽譜`}</a></li>
    </ul>
    <h2 name="youtube">Youtube の動画</h2>
    <h4>{`Roberto Alagna : "La fleur que tu m'avais jetée" (Carmen)`}</h4>
    <iframe width="100%" height="315" src="https://www.youtube.com/embed/P0tUnqvRanM" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <h4>{`Plácido Domingo - La Fleur Que Tu M'Avais Jetée, Live in Vienna, 1978`}</h4>
    <iframe width="100%" height="315" src="https://www.youtube.com/embed/jNgyhZFkgbo" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <h2 name="translation">対訳と語義解説</h2>
    <Note mdxType="Note">単語をクリック（タップ）すると解説が表示されます。</Note>
    <Part mdxType="Part">Don José</Part>
    <p>
  <Ex m="花" mdxType="Ex">La fleur</Ex> <Ex m="関係代名詞（英語のthat, which）" mdxType="Ex">que</Ex> tu <Ex m="私に" mdxType="Ex">m'</Ex><Ex m="投げる（複合過去）" o="jeter" mdxType="Ex">avais jetée</Ex>,
    </p>
    <Tr mdxType="Tr">おまえが投げてよこした花は</Tr>
    <p>
  <Ex m="〜の中で" mdxType="Ex">Dans</Ex> <Ex m="私の" mdxType="Ex">ma</Ex> <Ex m="牢獄" mdxType="Ex">prison</Ex>, <Ex m="私に" mdxType="Ex">m'</Ex><Ex m="とどまる（複合過去）" o="rester" mdxType="Ex">était restée</Ex>,
    </p>
    <Tr mdxType="Tr">牢獄の中でも、おれのもとにあった</Tr>
    <p>
  <Ex m="しおれた" mdxType="Ex">Flétrie</Ex> et <Ex m="乾燥した" mdxType="Ex">sèche</Ex>, <Ex m="この" mdxType="Ex">cette</Ex> <Ex m="花" mdxType="Ex">fleur</Ex>
    </p>
    <Tr mdxType="Tr">しおれて干からびてしまっても、この花は</Tr>
    <p>
  <Ex m="保つ" mdxType="Ex">Gardait</Ex> <Ex m="いつも" mdxType="Ex">toujours</Ex> <Ex m="その（ここでは「花の」）" mdxType="Ex">sa</Ex> <Ex m="甘い" mdxType="Ex">douce</Ex> <Ex m="香り" mdxType="Ex">odeur</Ex>;
    </p>
    <Tr mdxType="Tr">ずっとその甘い香りを保っていた</Tr>
    <p>
  Et <Ex m="〜の間ずっと" mdxType="Ex">pendant</Ex> <Ex m="数時間" mdxType="Ex">des heures</Ex> <Ex m="全体の、まるまる" mdxType="Ex">entières</Ex>,
    </p>
    <Tr mdxType="Tr">そして何時間もの間ずっと、</Tr>
    <p>
  <Ex m="〜の上に" mdxType="Ex">Sur</Ex> <Ex m="私の" mdxType="Ex">mes</Ex> <Ex m="目（ここでは複数形なので「両目」）" o="œil" mdxType="Ex">yeux</Ex>, <Ex m="閉じる（現在分詞）" o="fermer" mdxType="Ex">fermant</Ex> <Ex m="私の" mdxType="Ex">mes</Ex> <Ex m="まぶた" mdxType="Ex">paupières</Ex>,
    </p>
    <Tr mdxType="Tr">まぶたを閉じた目に、</Tr>
    <p>
  <Ex m="s'enivrer de ... 「...にうっとりする」" mdxType="Ex">De</Ex> <Ex m="この" mdxType="Ex">cette</Ex> <Ex m="香り" mdxType="Ex">odeur</Ex> je <Ex m="酔う、陶酔する（半過去）" o="s'enivrer" mdxType="Ex">m'enivrais</Ex>
    </p>
    <Tr mdxType="Tr">この香りに酔いしれながら</Tr>
    <p>
  Et <Ex m="〜の中で" mdxType="Ex">dans</Ex> <Ex m="夜、闇" mdxType="Ex">la nuit</Ex> je <Ex m="君を" mdxType="Ex">te</Ex> <Ex m="見る（半過去）" mdxType="Ex">voyais</Ex> !
    </p>
    <Tr mdxType="Tr">闇の中でおまえを思い描いていたんだ！</Tr>
    <p>
  Je <Ex m="〜し始める（半過去）" o="se prendre" mdxType="Ex">me prenais à</Ex> <Ex m="君を" mdxType="Ex">te</Ex> <Ex m="憎悪する、呪わしく思う" mdxType="Ex">maudire</Ex>,
    </p>
    <Tr mdxType="Tr">おまえを呪わしく思い始めた</Tr>
    <p>
  À te <Ex m="嫌う" mdxType="Ex">détester</Ex>, à <Ex m="自分自身に言う、思う" o="se dire" mdxType="Ex">me dire</Ex>:
    </p>
    <Tr mdxType="Tr">おまえを憎み、自分にこう言おうとした</Tr>
    <p>
  <Ex m="なぜ" mdxType="Ex">Pourquoi</Ex> <Ex m="〜しなければならない、〜する必要がある（il faut que 〜 の倒置）" mdxType="Ex">faut-il que</Ex> <Ex m="運命" mdxType="Ex">le destin</Ex>
    </p>
    <Tr mdxType="Tr">いったいどうして運命は</Tr>
    <p>
  <Ex m="彼女 (= Carmen)" mdxType="Ex">L'</Ex><Ex m="置く（接続法過去）" o="mettre" mdxType="Ex">ait mise</Ex> <Ex m="そこに" mdxType="Ex">là</Ex> <Ex m="〜の上に" mdxType="Ex">sur</Ex> <Ex m="私の" mdxType="Ex">mon</Ex> <Ex m="道" mdxType="Ex">chemin</Ex> !
    </p>
    <Tr mdxType="Tr">おれの進む道にあの女を置く必要があったのか！</Tr>
    <p>
  <Ex m="それから、次に" mdxType="Ex">Puis</Ex> je <Ex m="〜について自分を責める（半過去）" o="s'accuser" mdxType="Ex">m'accusais de</Ex> <Ex m="冒涜、暴言" mdxType="Ex">blasphème</Ex>,
    </p>
    <Tr mdxType="Tr">それから侮辱の言葉を吐いた自分を責めた</Tr>
    <p>
  Et je <Ex m="ne ... que 〜 「〜しか...ない」" mdxType="Ex">ne</Ex> <Ex m="感じる（半過去）" o="sentir" mdxType="Ex">sentais</Ex> <Ex m="〜に、〜の中に（抽象的な場所）" mdxType="Ex">en</Ex> <Ex m="私自身" mdxType="Ex">moi-même</Ex>,
    </p>
    <Tr mdxType="Tr">そして気づけばおれの中にあったのは、</Tr>
    <p>
  <Ex m="〜しか感じなかった" mdxType="Ex">Je ne sentais qu'</Ex><Ex m="たったひとつの" mdxType="Ex">un seul</Ex> <Ex m="願望" mdxType="Ex">désir</Ex>, un seul désir, un seul <Ex m="希望" mdxType="Ex">espoir</Ex>:
    </p>
    <Tr mdxType="Tr">たったひとつの願い、たったひとつの希望</Tr>
    <p>
  <Ex m="君を（に）" mdxType="Ex">Te</Ex> <Ex m="もう一度会う" mdxType="Ex">revoir</Ex>, ô Carmen, oui, te revoir !
    </p>
    <Tr mdxType="Tr">おまえにもう一度会うこと、おお、カルメン、そうなんだ、おまえにもう一度会うこと！</Tr>
    <p>
  <Ex m="なぜなら、というのは" mdxType="Ex">Car</Ex> tu <Ex m="n'avoir qu'à 〜「〜しさえすればよい」（大過去）この数行の直訳は「なぜって、おれのすべてを支配するために、おまえはただ現れておれに一瞥をくれてやるだけでよかったのだから」" o="avoir" mdxType="Ex">n'avais eu qu'à</Ex> <Ex m="現れる" mdxType="Ex">paraître</Ex>,
    </p>
    <Tr mdxType="Tr">なぜっておまえはただ現れて、</Tr>
    <p>
  <Ex m="直前のqu'à paraîtreと並列" mdxType="Ex">Qu'à</Ex> <Ex m="投げる" mdxType="Ex">jeter</Ex> <Ex m="視線、一瞥" mdxType="Ex">un regard</Ex> <Ex m="〜の上に" mdxType="Ex">sur</Ex> <Ex m="私" mdxType="Ex">moi</Ex>
    </p>
    <Tr mdxType="Tr">おれに一瞥しただけで、</Tr>
    <p>
  <Ex m="〜するために" mdxType="Ex">Pour</Ex> <Ex m="(de 〜) 〜を奪取する、とらえる" o="s'emparer" mdxType="Ex">t'emparer</Ex> de <Ex m="すべての" mdxType="Ex">tout</Ex> <Ex m="私の" mdxType="Ex">mon</Ex> <Ex m="心、魂、存在" mdxType="Ex">être</Ex>,
    </p>
    <Tr mdxType="Tr">おれのすべてを支配してしまったんだ</Tr>
    <p>
  Ô <Ex m="私の" mdxType="Ex">ma</Ex> Carmen !
    </p>
    <Tr mdxType="Tr">おお、おれのカルメン！</Tr>
    <p>
  Et j'<Ex m="〜である（半過去）（英語のbe動詞）" mdxType="Ex">étais</Ex> <Ex m="もの" mdxType="Ex">une chose</Ex> <Ex m="この à は所属、所有を表す「〜に属する、〜の」" mdxType="Ex">à</Ex> <Ex m="君" mdxType="Ex">toi</Ex> !
    </p>
    <Tr mdxType="Tr">おれはおまえのものだったんだ！</Tr>
    <p>
  Carmen, je <Ex m="君を" mdxType="Ex">t'</Ex><Ex m="愛する" o="aimer" mdxType="Ex">aime</Ex> !
    </p>
    <Tr mdxType="Tr">カルメン、愛している！</Tr>
    <h2 name="sheet">楽譜</h2>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/444172adbd6571ad4dec186ef9712aea/8698d/carmen-la-fleur.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "141.5%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAcCAYAAABh2p9gAAAACXBIWXMAABcSAAAXEgFnn9JSAAAC/ElEQVRIx6XWx24kMQwE0Pn/r7IPPhjOOeeccw5aPALVaI992wZoBVJkkUVpPGj/+b2/v7ePj4+S7+/vNvDn8fGxvby8dErj19dXZ/j5+dnp3t7e2uvra3t+fq5zt7e37erqql1fX5d+QDk6OtoWFxfb8fFx29raamtra212drb2NjY22uHhYY1kZWWl7e3tlW5iYqLt7++3zc3NOifYABIo8wWt8eHhoaKyEdg+ZA5CTW+e1CtlB6DZ3d2tKCLu7Oy0k5OTdnp62g4ODtr5+Xmt6c/Ozmrf/OjoqLJaWlqqM4WQ5+3t7XZ5eVmpcrC6ulp7HC0vL1eKHElZeuYc2udQGdbX1wt1kSIV3p+enmq0vr+/rzRDAh2RMrHHBilAsVOaImVkZKSigy3y3NxcIZO+Nd3MzEyhg1wmxqmpqToDnbQBKVL6hIh0d3fXFRwCyIwOkLRNbJwjvo4UERX74uKi5iEGGgjpIEYeCUlqqKbGjhSHIYAMKRwY9R8dRxgN6wJyYt+cc2u+upsijaSi63NzCPbSfyEj5N3c3NS660MKN0UkxZ2eni5SSEiSjnXSZ6NV6LXYwsJC6f8kheRmEDVGinJACS2bzH3I4ay7KehXG0jUSk3M1cioduqp0TUzW2Oa3uNA35FiU90cTufnCmIdq1IVLLcp/ZfuMJZDMPs3JM9S0krfSSvkpR/poUv//iAlT9P8/HyVwJwgABLIxsbGCpkbMz4+XilDmzO/SMmDmnsZtCl+5spEl1Zhb/2DFHUSUZtkrrZ5PCE0V3x1NvfIpo5s68UOKdqCkRRyzTxpGM+VwzIxRxadAMRNqdcGzPRRnxREuQF5rlxNaynH1tpN4UyAeg/zmwIdyYOgDNKWkpSTHoQI9KCwo3MOWQIPhn9P+gjzZOUBtaZXKyVKFpCF3CJlcnKy63gN7qD6JRVzorZxlFTzfDlL1/2mWHBE6TAD6TuYmrHJr2KC0pvjQfkGw/8JgJ++8/VLMvzJbvirGvblL0fDNn3b4b1/9yxAjiU33VMAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "楽譜",
            "title": "楽譜",
            "src": "/static/444172adbd6571ad4dec186ef9712aea/5a190/carmen-la-fleur.png",
            "srcSet": ["/static/444172adbd6571ad4dec186ef9712aea/772e8/carmen-la-fleur.png 200w", "/static/444172adbd6571ad4dec186ef9712aea/e17e5/carmen-la-fleur.png 400w", "/static/444172adbd6571ad4dec186ef9712aea/5a190/carmen-la-fleur.png 800w", "/static/444172adbd6571ad4dec186ef9712aea/c1b63/carmen-la-fleur.png 1200w", "/static/444172adbd6571ad4dec186ef9712aea/8698d/carmen-la-fleur.png 1239w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      